import React from 'react';
import { useHistory } from 'react-router-dom';
import { TicketKey } from 'flow/types/EntityKeys';
import { generatePath } from 'flow/utils/router-utils';
import { routes } from 'flow/types/routes';
import { getTicketIdUiFriendly } from 'flow/utils/ticket-utils';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    ticketKey: TicketKey;
    className?: string;
}

const WidgetGoToTicket = ({ ticketKey, className }: Props) => {
    const { i18next } = useAppContext();
    const history = useHistory();

    return (
        <div className={twMerge('h-9 min-w-0', className)}>
            <button
                className="size-full cursor-pointer rounded-sm bg-gray-700 text-xs text-white"
                onClick={() =>
                    history.push(
                        generatePath(routes['tickets.ticketKey'], {
                            ticketKey,
                        }),
                    )
                }
            >
                <div className="flex size-full items-center justify-between gap-x-4 p-3">
                    <div className="truncate font-light">
                        {i18next.t('tickets.go_to')}
                    </div>
                    <div className="shrink-0 tracking-wide">
                        {getTicketIdUiFriendly(ticketKey)}
                    </div>
                </div>
            </button>
        </div>
    );
};

export default WidgetGoToTicket;
